import * as React from 'react';
import {observer} from 'mobx-react';
import {Form as IForm, FormField, FormFields} from '../types/form';
import {Form} from './form';
import {style} from 'typestyle';
import {px} from 'csx';

export interface PageCheckoutVatNumberFields extends FormFields {
  vatNumber: FormField<string>;
}

export type PageCheckoutVatNumberModel = IForm<PageCheckoutVatNumberFields>;

export interface PageCheckoutVatNumberProps {
  model: PageCheckoutVatNumberModel;
  onChange(vatNumber: string): void;
}

@observer
export class PageCheckoutVatNumber extends React.Component<PageCheckoutVatNumberProps, {}> {
  render() {
    const { onChange, model } = this.props;

    return (
      <Form
        className={PageCheckoutVatNumber.styles.form}
        model={model}
        onChange={(_, vatNumber) => onChange(vatNumber)}
        noButtons={true}
      />
    )
  }

  static styles = {
    form: style({
      maxWidth: px(640),
    })
  }
}